import {
  recordLiveEditPreviewClear,
  recordLiveEditPreviewPatch,
} from "../debug/listenerProbe.ts";
import {
  type ActiveEditSession,
  type EditSessionGeometryPatch,
  type EditSessionPatch,
  extractEditSessionPatch,
  patchActiveEditSession,
} from "./editSession.ts";

interface LiveEditPreviewStore {
  session: ActiveEditSession | null;
  version: number;
}

let store: LiveEditPreviewStore = {
  session: null,
  version: 0,
};

const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeLiveEditPreview(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getLiveEditPreviewSession(): ActiveEditSession | null {
  return store.session;
}

export function getLiveEditPreviewVersion(): number {
  return store.version;
}

export function getLiveEditPreviewForObject(
  objectId: string | null | undefined,
): ActiveEditSession | null {
  if (!objectId) return null;
  return store.session?.objectId === objectId ? store.session : null;
}

export function patchLiveEditPreview(
  objectId: string,
  patch: EditSessionPatch,
): ActiveEditSession {
  const current = store.session?.objectId === objectId ? store.session : null;
  const session = patchActiveEditSession(current, objectId, patch);
  store = {
    session,
    version: store.version + 1,
  };
  recordLiveEditPreviewPatch();
  emit();
  return session;
}

export function clearLiveEditPreview(objectId?: string): void {
  if (!store.session) return;
  if (objectId && store.session.objectId !== objectId) return;
  store = {
    session: null,
    version: store.version + 1,
  };
  recordLiveEditPreviewClear();
  emit();
}

export function extractLiveEditPreviewPatch(
  objectId: string | null | undefined,
): EditSessionGeometryPatch | null {
  const session = getLiveEditPreviewForObject(objectId);
  return session ? extractEditSessionPatch(session) : null;
}
